import constants from 'common/constants'

import {
  ADD_CLASS,
  ADD_CLASS_RESOURCE,
  ASSIGN_TEACHERS,
  CLASS_STUDENT_SUBJECT_REPORT,
  DELETE_CLASS,
  DELETE_CLASS_RESOURCE,
  DELETE_MANY_CLASSES,
  GENERATE_CLASS_STREGNTH_LIST,
  GET_CLASS,
  GET_CLASSES,
  GET_CLASS_RESOURCES,
  GET_CLASS_STUDENTS,
  GET_CLASS_SUBJECTS,
  GET_PREVIOUS_CLASSES,
  GET_STUDENTS_FROM_MULTIPLE_CLASSES,
  GET_SUBJECTS_CLASSES,
  INACTIVATE_CLASS,
  PROMOTE_STUDENTS,
  REDUX_GET_CLASSES,
  UPDATE_CLASS,
  UPDATE_CLASS_SEQUENCE,
} from './ActionTypes/ApiActionTypes'

export const getClasses = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_CLASSES,
    payload: {
      apiUrl: constants.api_get_classes,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_CLASSES : '',
      onSuccess,
      onFailure,
    },
  }
}

export const getClass = (id, onSuccess, onFailure) => {
  return {
    type: GET_CLASS,
    payload: {
      apiUrl: constants.api_get_class(id),
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const addClass = (body, onSuccess, onFailure) => {
  return {
    type: ADD_CLASS,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_add_class,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const deleteClass = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_CLASS,
    payload: {
      apiUrl: constants.api_delete_class(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

/**
 * Inactivate a class. Refused with code `CLASS_HAS_ACTIVE_STUDENTS` while the
 * class still has active students; resend with `body.inactivateStudents` and
 * the inactivation reason to take them along.
 * @param {number} id class id
 * @param {object} [body]
 * @param {boolean} [body.inactivateStudents] also inactivate the class's active students
 * @param {number} [body.inactive_reason] USER_INACTIVE_REASON value, required with inactivateStudents
 * @param {string} [body.inactivation_custom_reason] required when inactive_reason is OTHER
 * @param {(res: object) => void} [onSuccess]
 * @param {(err: object) => void} [onFailure]
 */
export const inactivateClass = (id, body = {}, onSuccess, onFailure) => {
  return {
    type: INACTIVATE_CLASS,
    payload: {
      apiUrl: constants.api_inactivate_class(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const deleteManyClasses = (ids, onSuccess, onFailure) => {
  return {
    type: DELETE_MANY_CLASSES,
    payload: {
      apiUrl: constants.api_delete_many_classes,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      body: {ids: ids},
      onSuccess,
      onFailure,
    },
  }
}
export const updateClass = (id, data, onSuccess, onFailure) => {
  return {
    type: UPDATE_CLASS,
    payload: {
      apiUrl: constants.api_update_class(id),
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const updateClassSequence = (data, onSuccess, onFailure) => {
  return {
    type: UPDATE_CLASS_SEQUENCE,
    payload: {
      apiUrl: constants.api_update_class_sequence,
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getClassResources = (data, onSuccess, onFailure) => {
  return {
    type: GET_CLASS_RESOURCES,
    payload: {
      apiUrl: constants.api_get_class_resources,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: REDUX_GET_CLASSES,
      onSuccess,
      onFailure,
    },
  }
}

export const addClassResource = (body, onSuccess, onFailure) => {
  return {
    type: ADD_CLASS_RESOURCE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_add_class_resource,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const deleteResource = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_CLASS_RESOURCE,
    payload: {
      apiUrl: constants.api_delete_class_resource(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getClassSubjects = (id, data, onSuccess, onFailure) => {
  return {
    type: GET_CLASS_SUBJECTS,
    payload: {
      apiUrl: constants.api_get_class_subjects(id),
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
export const getClassStudents = (body, onSuccess, onFailure) => {
  return {
    type: GET_CLASS_STUDENTS,
    payload: {
      apiUrl: constants.api_get_class_students(body.id),
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const getStudentsFromMultipleClasses = (body, onSuccess, onFailure) => {
  return {
    type: GET_STUDENTS_FROM_MULTIPLE_CLASSES,
    payload: {
      apiUrl: constants.api_get_students_from_multiple_classes,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: body,
      onSuccess,
      onFailure,
    },
  }
}

export const generateClassStrengthList = (body, onSuccess, onFailure) => {
  return {
    type: GENERATE_CLASS_STREGNTH_LIST,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_generate_class_strength_list,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}
export const promoteStudents = (data, onSuccess, onFailure) => {
  return {
    type: PROMOTE_STUDENTS,
    payload: {
      apiUrl: constants.api_promote_students,
      getString: '',
      body: data,
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getPreviousClasses = (data, onSuccess, onFailure) => {
  return {
    type: GET_PREVIOUS_CLASSES,
    payload: {
      apiUrl: constants.api_get_previous_classes,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      reduxActionType: '',
      body: data,
      onSuccess,
      onFailure,
    },
  }
}

export const assignTeachers = (data, onSuccess, onFailure) => {
  return {
    type: ASSIGN_TEACHERS,
    payload: {
      apiUrl: constants.api_assign_teachers,
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const generateClassStudentSubjectReport = (body, onSuccess, onFailure) => {
  return {
    type: CLASS_STUDENT_SUBJECT_REPORT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_generate_class_student_subject_report,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const subjectsClasses = (body, onSuccess, onFailure) => {
  return {
    type: GET_SUBJECTS_CLASSES,
    payload: {
      apiUrl: constants.api_get_subjects_classes,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
